import { Component, DoCheck, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { CartaoClienteService } from '../../services/cartao-cliente.service';
import { CartaoCliente } from '../cadastro-cartao-cliente/cadastro-cartao-cliente.component';
const QRCode = require('qrcode');

@Component({
  selector: 'app-novo-cartao-cliente',
  templateUrl: './novo-cartao-cliente.component.html',
  styleUrls: ['./novo-cartao-cliente.component.scss']
})
export class NovoCartaoClienteComponent implements OnInit {
  @ViewChild('frm') form: NgForm;
  
  cartao: CartaoCliente;
  empresa: any;
  windowRef: DialogRef;
  loading = false;
  mensagemErro: string;
  qrCodePreviewUrl: string = '';
  private ultimoCodigoQrGerado: string = '';

  constructor(private cartaoClienteService: CartaoClienteService) {
    this.cartao = new CartaoCliente();
  }

  ngOnInit() {
  }

  ngDoCheck() {
    const codigoAtual = this.normalizarCodigo(this.cartao?.codigo);
    if (codigoAtual === this.ultimoCodigoQrGerado) {
      return;
    }

    this.ultimoCodigoQrGerado = codigoAtual;
    this.atualizarPreviewQrCode();
  }

  salvar() {
    this.mensagemErro = '';

    if (this.form?.form) {
      this.form.form.markAllAsTouched();
    }

    this.cartao.codigo = this.normalizarCodigo(this.cartao?.codigo);
    this.cartao.codigoPdv = this.normalizarCodigo(this.cartao?.codigoPdv);

    const mensagemValidacao = this.obtenhaMensagemValidacaoFormulario();
    if (mensagemValidacao) {
      this.mensagemErro = mensagemValidacao;
      return;
    }

    this.loading = true;
    this.cartao.empresa = this.empresa;

    const promise = this.cartao.id ?
      this.cartaoClienteService.atualizeCartao(this.cartao) :
      this.cartaoClienteService.insiraCartao(this.cartao);

    promise
      .then(async (cartaoSalvo: any) => {
        if (!this.cartao.id) {
          const cartaoConfirmado = await this.confirmeCartaoCriado(cartaoSalvo);
          if (!cartaoConfirmado) {
            this.loading = false;
            this.mensagemErro = 'Não foi possível confirmar a criação do cartão. Tente novamente.';
            return;
          }

          this.loading = false;
          this.windowRef.close(cartaoConfirmado);
          return;
        }

        this.loading = false;
        this.windowRef.close(cartaoSalvo || this.cartao);
      })
      .catch((erro) => {
        this.loading = false;
        console.log(erro);
        this.mensagemErro = this.obtenhaMensagemErro(erro);
      });
  }

  fechar() {
    this.windowRef.close();
  }

  criarCartao() {
    if (!this.cartao.codigo || !this.empresa) {
      return;
    }

    const dadosCartao = {
      codigo: this.cartao.codigo,
      codigoPdv: this.cartao.codigoPdv,
      empresa: {
        id: this.empresa.id
      },
      ativo: true
    };

    this.cartaoClienteService.crieCartao(dadosCartao)
      .then((response) => {
        this.windowRef.close();
        // Emitir evento de sucesso se necessário
      })
      .catch((erro) => {
        this.mensagemErro = this.obtenhaMensagemErro(erro);
        console.error(erro);
      });
  }

  async atualizarPreviewQrCode() {
    const codigo = this.normalizarCodigo(this.cartao?.codigo);

    if (!codigo) {
      this.qrCodePreviewUrl = '';
      return;
    }

    try {
      this.qrCodePreviewUrl = await QRCode.toDataURL(codigo, {
        width: 240,
        margin: 1
      });
    } catch (erro) {
      console.error('Erro ao gerar preview do QR code do cartão cliente', erro);
      this.qrCodePreviewUrl = this.obtenhaUrlQrCode(codigo);
    }
  }

  obtenhaUrlQrCode(codigo: string): string {
    const codigoNormalizado = this.normalizarCodigo(codigo);
    if (!codigoNormalizado) {
      return '';
    }

    return `/qrcode/${encodeURIComponent(codigoNormalizado)}`;
  }

  private normalizarCodigo(codigo: any): string {
    return String(codigo || '').trim();
  }

  private obtenhaMensagemValidacaoFormulario(): string | null {
    const codigo = this.normalizarCodigo(this.cartao?.codigo);
    const codigoPdv = this.normalizarCodigo(this.cartao?.codigoPdv);

    if (!codigo) {
      return 'Informe o código do cartão.';
    }

    if (codigo.length > 20) {
      return 'O código do cartão deve ter no máximo 20 caracteres.';
    }

    if (codigoPdv && codigoPdv.length > 100) {
      return 'O código PDV deve ter no máximo 100 caracteres.';
    }

    return null;
  }

  private obtenhaMensagemErro(erro: any): string {
    if (typeof erro === 'string' && erro.trim()) {
      return erro;
    }

    return erro?.error?.message || erro?.message || 'Erro ao salvar o cartão. Tente novamente.';
  }

  private async confirmeCartaoCriado(cartaoSalvo: any): Promise<any> {
    if (this.cartaoCriadoComSucesso(cartaoSalvo)) {
      return cartaoSalvo;
    }

    const codigo = this.normalizarCodigo(this.cartao?.codigo);
    if (!codigo) {
      return null;
    }

    try {
      const cartoes = await this.cartaoClienteService.obtenhaCartoes();
      return (cartoes || []).find((cartao: any) => this.normalizarCodigo(cartao?.codigo) === codigo) || null;
    } catch (erro) {
      return null;
    }
  }

  private cartaoCriadoComSucesso(cartaoSalvo: any): boolean {
    if (!cartaoSalvo) {
      return false;
    }

    const idValido = cartaoSalvo.id != null && String(cartaoSalvo.id).trim() !== '';
    const codigoValido = cartaoSalvo.codigo != null && String(cartaoSalvo.codigo).trim() !== '';
    return idValido || codigoValido;
  }
}
